import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { IResponseInfo } from 'i2g-ng-utils';
import { AccountService } from '../store/services';

@Injectable()
export class VerifyEmailResolve implements Resolve<boolean> {
  constructor(private _accountService: AccountService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const queryParams = route.queryParams;
    const attemptId = queryParams['verify_email_attempt_id'];
    const verificationCode = queryParams['verification_code'];
    return this._accountService.verifyEmail(attemptId, verificationCode).pipe(
      take(1),
      catchError(() => {
        return of(false);
      }),
      map((result: IResponseInfo) => {
        return result.status === 200;
      })
    );
  }
}
